import React, { Component } from 'react';
import PropTypes from 'prop-types';
import App from './screens/App';
import { setSessionStorage, clearSessionStorage } from './helpers/session';

class Module extends Component {
  componentWillMount() {
    if (this.props.moduleData) {
      setSessionStorage(this.props.moduleData);
    }
  }

  componentWillUnmount() {
    clearSessionStorage();
  }

  render() {
    return <App />;
  }
}

Module.propTypes = {
  moduleData: PropTypes.object,
};

export default Module;



// WEBPACK FOOTER //
// ./src/Module.js